'use client'

import PropTypes from 'prop-types'
import MUISelect from '@mui/material/Select'
import MUIMenuItem from '@mui/material/MenuItem'
import { useFeeEarnerStore } from '@repo/store/useFeeEarnerStore'

export const FeeEarnerFilter = ({ value, onChange, width = '320px', feeEarners_DI, sx }) => {
  const { feeEarners } = useFeeEarnerStore()
  const items = feeEarners_DI || feeEarners

  const renderSelection = (selected) => {
    if (!selected || selected.length === 0) return 'Select'

    const labels = selected?.map((id) => {
      const fe = feeEarners?.find((fe) => fe.feeEarnerId === id)
      return fe?.description || ''
    })

    if (selected.length === 1) return labels[0]
    return `${labels[0]} + ${selected.length - 1}`
  }

  if (!items || !feeEarners) return <div data-testid="FeeEarnerFilter" />

  return (
    <MUISelect
      data-testid="FeeEarnerFilter"
      label="Fee earners"
      multiple
      value={value}
      renderValue={renderSelection}
      sx={{ width, ...sx }}
    >
      {renderOptions(items, width, onChange, value)}
    </MUISelect>
  )
}

const renderOptions = (items, width, onChange, currentValue) => {
  const onClick = (feeEarnerId) => {
    if (onChange) {
      if (currentValue.includes(feeEarnerId)) {
        onChange(currentValue.filter((id) => id !== feeEarnerId))
      } else {
        onChange([...currentValue, feeEarnerId])
      }
    }
  }
  const options = items.map((fe, index) => (
    <MUIMenuItem
      sx={menuItemStyles(width)}
      onClick={() => (onChange ? onClick(fe.feeEarnerId) : null)}
      key={`${fe.feeEarnerId}-${index}`}
      value={fe.feeEarnerId}
    >
      {fe.description}
    </MUIMenuItem>
  ))

  return options
}

const menuItemStyles = (width) => ({
  margin: '6px 6px',
  borderRadius: '4px',
  cursor: 'pointer',
  width: `${width - 20}px`
})

FeeEarnerFilter.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  width: PropTypes.string,
  feeEarners_DI: PropTypes.array,
  multiple: PropTypes.bool,
  sx: PropTypes.object
}
